// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var submitButton = "forms-module--submitButton--2q8Rg";
export var disabled = "forms-module--disabled--12elk";
export var submitButtonReady = "forms-module--submitButtonReady--DM1wD";
export var submitButtonDisabled = "forms-module--submitButtonDisabled--2_g8W";
export var submitButtonSubmitting = "forms-module--submitButtonSubmitting--HGlsE";
export var submitButtonLoadingIcon = "forms-module--submitButtonLoadingIcon--2BDKy";
export var rotation = "forms-module--rotation--3X_R1";
export var submitButtonFailed = "forms-module--submitButtonFailed--2LXUc";
export var submitButtonSubmitted = "forms-module--submitButtonSubmitted--2MmXZ";
export var formErrors = "forms-module--formErrors--2IJQX";